function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}><path d="M9.9 2c-3.8 0-7 3.1-7 7 0 1.2.3 2.4.9 3.4l-2.2-.8c-.4-.1-.8.1-.9.5-.1.2-.1.4 0 .6.1.2.3.3.4.3L5 14.5h.2c.3 0 .6-.2.7-.5l1.6-3.7c.1-.2.1-.4 0-.6-.1-.2-.3-.3-.4-.4-.4-.1-.8.1-.9.5l-.9 2c-.5-.9-.8-1.8-.8-2.8 0-3 2.4-5.4 5.4-5.4S15.3 6 15.3 9s-2.4 5.4-5.4 5.4c-.4 0-.8.4-.8.8s.4.8.8.8c3.8 0 7-3.1 7-7 0-3.8-3.1-7-7-7z" fill="currentColor" /></svg>;
});